/* eslint-disable no-alert, no-param-reassign */

import { createApp, configureCompat } from '@vue/compat';
import * as Sentry from '@sentry/vue';
import Select2 from '../components/select2.vue';
import Datepicker from '../components/datepicker.vue';
import OnetPicker from '../components/onet_picker.vue';
import IpedsPicker from '../components/ipeds_picker.vue';
import CipPicker from '../components/cip_picker.vue';
import NaicsPicker from '../components/naics_picker.vue';
import OfficePicker from '../components/office_picker.vue';
import RapidsPicker from '../components/rapids_picker.vue';
import '../modules/modal_focus_management';
import '../modules/address_book_label';

export function registerGlobalComponents(app) {
  app.component('Select2', Select2);
  app.component('datepicker', Datepicker);
  app.component('onetpicker', OnetPicker);
  app.component('ipedspicker', IpedsPicker);
  app.component('cippicker', CipPicker);
  app.component('naicspicker', NaicsPicker);
  app.component('officepicker', OfficePicker);
  app.component('rapidspicker', RapidsPicker);

  app.config.compilerOptions.whitespace = 'preserve';
  // Add compat config to every app
  configureCompat({
    MODE: 2,
    COMPONENT_V_MODEL: 'suppress-warning',
    INSTANCE_ATTRS_CLASS_STYLE: false,
    WATCH_ARRAY: false,
    ATTR_FALSE_VALUE: false,
  });
}

const pickerTypes = [
  'datepicker',
  'onetpicker',
  'ipedspicker',
  'cippicker',
  'naicspicker',
  'rapidspicker',
  'officepicker',
];

let vueApp = null;

export function getVueApp() {
  if (!vueApp) {
    vueApp = createApp({});
    registerGlobalComponents(vueApp);
  }
  return vueApp;
}

function attachPickerComponents(parent) {
  const list = [];

  pickerTypes.forEach((name) => {
    const elements = Array.from(parent.querySelectorAll(name));

    elements.forEach((element) => {
      const instance = createApp({
        template: element.outerHTML,
      });

      registerGlobalComponents(instance);

      list.push(instance.mount(element));
    });
  });
  return list;
}

global.attachPickerComponents = attachPickerComponents;

document.addEventListener('DOMContentLoaded', () => {
  const app = getVueApp();

  if (process.env.RAILS_ENV === 'production') {
    Sentry.init({
      dsn: 'https://41c76badf8dd42cf9c908ee883619619@o181468.ingest.us.sentry.io/1424323',
      app,
      tracesSampleRate: 0.0, // Disable performance monitoring, errors are still logged.
    });
  }

  window.pageComponents = attachPickerComponents(document);
  global.Vue = app;

  $(document).on('cocoon:after-insert', (e, insertedItem) => {
    const inputs = insertedItem.find(pickerTypes.join(','));
    $.each(inputs, (_key, value) => {
      const inputId = value.getAttribute('input-id');
      if (inputId !== 'undefined' && inputId != null) {
        const targetElement = document.querySelector(`[input-id="${inputId}"]`);
        if (targetElement) {
          const instance = createApp({
            template: targetElement.outerHTML,
          });

          registerGlobalComponents(instance);

          instance.mount(targetElement);
        }
      }
    });
  });

  $('.ui-datepicker').addClass('notranslate');

  window.confirmDialog = function confirmDialog(event, url) {
    event.preventDefault();
    if (confirm('You are about to leave this site and navigate to an external website. Do you want to continue?')) {
      window.open(url, '_blank');
    }
  };
});
